import { createContext, useContext } from 'react';

import { DictionaryTypeDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';

export type DictionariesContextProps = Record<
  DictionaryTypeDto,
  SelectSearchOptionModel<number>[]
> &
  Record<'USERS_SHORT', SelectSearchOptionModel[]>;

export const DictionariesDefaultValues: DictionariesContextProps = {
  [DictionaryTypeDto.CarDeadlineType]: [],
  [DictionaryTypeDto.CarType]: [],
  [DictionaryTypeDto.DietaryPreference]: [],
  [DictionaryTypeDto.DishDepartment]: [],
  [DictionaryTypeDto.DishType]: [],
  [DictionaryTypeDto.EmergencyContactCategoryType]: [],
  [DictionaryTypeDto.EventType]: [],
  [DictionaryTypeDto.MenuType]: [],
  [DictionaryTypeDto.PackageOfferItem]: [],
  [DictionaryTypeDto.PredefinedOffer]: [],
  [DictionaryTypeDto.SupplierType]: [],
  [DictionaryTypeDto.Tag]: [],
  ['USERS_SHORT']: [],
};
export const DictionariesContext =
  createContext<DictionariesContextProps>(DictionariesDefaultValues);

export const useDictionariesContext = (): DictionariesContextProps => {
  return useContext<DictionariesContextProps>(DictionariesContext);
};
